import type { GroupCardContent } from '../app/types/shared';

export const getRelatedElement = (card: GroupCardContent, position: number) => ({
  elementName: 'link',
  elementValue: `${position.toString()}-${card.cardTitle}`,
});
